import { getGameById } from '@/helpers/getGameById';

export function getGameShortname(id: number | string): string | undefined {
  const game = getGameById(id);
  return game ? game.shortname : undefined;
}
